import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_public",
  "use": "micro_public-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_public\"><path d=\"M5 0a5 5 0 1 1 0 10A5 5 0 0 1 5 0ZM1.009 4.734a3.998 3.998 0 0 0 3.94 4.264c.01-.265-.173-.398-.549-.398-.732 0-1.16-.586-1.284-1.758Zm5.71-3.346-.02.052A1 1 0 0 1 5.8 2H4.4v.926l-.007.117a1 1 0 0 1-.993.883h-.8V5h3.2l.117.007A1 1 0 0 1 6.8 6v1.4l.205.009c.415.026.749.103 1 .23A4 4 0 0 0 6.72 1.388Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol